import React from "react";
import {Link} from "react-router-dom";
import {StyledButton} from "../../../Common/Components";
import { PermissionNames } from "~enums/permissions";
import { UploadImageListView } from "~components/Images";
import { ImageTypes } from "~enums/imageTypes";
import { ImageBaseTypes } from "~enums/imageBaseTypes";

export const getColumns = ({formatMessage, customerId, sport}) => [
    {
        title: formatMessage({
            id: "name.local.full",
            defaultMessage: "Local Full Name",
        }),
        dataIndex: "nameFullLocal",
    },
    {
        title: formatMessage({
            id: "images.headshot",
            defaultMessage: "Head Shot Photo",
        }),
        render: (value, row) => (
          <UploadImageListView
            baseType={ImageBaseTypes.Person}
            baseId={row.personId}
            imageType={ImageTypes.PersonHead}
            images={row.images}
            permissionKey={PermissionNames.PERSON}
          />
        ),
    },
    {
        title: formatMessage({
            id: "images.waist",
            defaultMessage: "Waist Shot Photo",
        }),
        render: (value, row) => (
          <UploadImageListView
            baseType={ImageBaseTypes.Person}
            baseId={row.personId}
            imageType={ImageTypes.PersonWaist}
            images={row.images}
            permissionKey={PermissionNames.PERSON}
          />
        ),
    },
    {
        title: formatMessage({
            id: "images.pose",
            defaultMessage: "Posed / Action Shot Photo",
        }),
        render: (value, row) => (
          <UploadImageListView
            baseType={ImageBaseTypes.Person}
            baseId={row.personId}
            imageType={ImageTypes.PersonPose}
            images={row.images}
            permissionKey={PermissionNames.PERSON}
          />
        ),
    },
    {
        render: (value, row) => (
            <StyledButton type="text" size="small">
                <Link to={`/${customerId}/admin/${sport}/${row.organizationId}/persons/manage/${row.personId}`}>
                    {formatMessage({
                        id: "details",
                        defaultMessage: "Details",
                    })}
                </Link>
            </StyledButton>
        ),
    },
];
